var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentcolor",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.996 40h-8.282V27.007c0-3.098-.055-7.086-4.307-7.086-4.313 0-4.973 3.375-4.973 6.86V40h-8.282V13.281h7.95v3.651h.112a8.72 8.72 0 0 1 7.844-4.315c8.394 0 9.942 5.53 9.942 12.726zM4.807 9.629C2.17 9.629 0 7.456 0 4.815S2.17 0 4.806 0s4.806 2.173 4.806 4.814S7.443 9.63 4.807 9.63ZM8.948 40H.658V13.281h8.29z"
  })));
};
export default SvgLinkedin;